import { motion, useSpring, useMotionValue } from "framer-motion"
import { useEffect } from "react"

export default function FlyingCursor() {
    // Track mouse position with motion values
    const mouseX = useMotionValue(0)
    const mouseY = useMotionValue(0)

    // Apply spring animation
    const springX = useSpring(mouseX, { stiffness: 100, damping: 15 })
    const springY = useSpring(mouseY, { stiffness: 100, damping: 15 })

    useEffect(() => {
        const handleMouseMove = (event: { clientX: number; clientY: number }) => {
            mouseX.set(event.clientX)
            mouseY.set(event.clientY)
        }

        window.addEventListener("mousemove", handleMouseMove)
        return () => window.removeEventListener("mousemove", handleMouseMove)
    }, [mouseX, mouseY])

    return (
        <motion.div
            className="hidden lg:block fixed z-[510] top-0 left-0 w-12 h-12 border-2 border-primary rounded-full pointer-events-none"
            style={{
                translateX: springX,
                translateY: springY,
            }}
        />
    )
}
